import api from "../apis/CourseApi";
// import * as constant from "../constants/PlanConstants";

export const GetSingleCourse = (data,onSuccess,onError) => (dispatch) => {
  api
    .Courses()
    .getAcourse(data)
    .then((res) => {
        onSuccess(res.data);
    })
    .catch((err) => {
      if (err.code === 'ECONNABORTED'){
        onError("Timeout");
      }else{
        onError(err.response.data.message);
      }
    });
};

export const BuyACourse = (data,onSuccess,onError) => (dispatch) => {
  api
    .Courses()
    .buyAcourse(data)
    .then((res) => {
        onSuccess(res.data);
    })
    .catch((err) => {
      if (err.code === 'ECONNABORTED'){
        onError("Timeout");
      }else{
        onError(err.response.data.message);
      }
    });
};
